export default __webpack_public_path__ + "static/media/ic_share.cc319fd3.svg";